import { debounce } from '../../functions/debounce';
export default function listFilter() {
    const form = document.querySelector('[data-filter-form]');
    const input = document.querySelector(`[data-filter-input]`);
    const resultStatus = document.querySelector('[data-filter-status]');
    const resultHits = document.querySelector('[data-filter-hits]');
    const list = document.querySelector('[data-filter-list]');
    const listItems = list?.querySelectorAll(':scope > li');
    const texts = {
        hit: form?.dataset.filterLiveareaHit,
        hits: form?.dataset.filterLiveareaHits,
        inlist: form?.dataset.filterLiveareaInlist,
    };
    const createStatusText = (number) => {
        return `${number} ${number === 1 ? texts.hit : texts.hits} ${texts.inlist}`;
    };
    const createHitsText = (number) => {
        return `${number} ${number === 1 ? texts.hit : texts.hits}`;
    };
    const handleStatus = debounce((number) => {
        if (resultStatus)
            resultStatus.innerText = createStatusText(number);
    }, 1000);
    const handleHits = (number) => {
        if (resultHits) {
            resultHits.innerText = createHitsText(number);
        }
    };
    const handleInputChange = (e) => {
        let noLi = listItems?.length ?? 0;
        const target = e.target;
        listItems?.forEach(function (item) {
            const query = item.textContent || '';
            if (query.toLowerCase().indexOf(target.value.toLowerCase()) > -1) {
                item.hidden = false;
                item.classList.remove('spv-displayHidden');
            }
            else {
                item.hidden = true;
                item.classList.add('spv-displayHidden');
                noLi--;
            }
        });
        handleStatus(noLi);
        handleHits(noLi);
    };
    handleHits(listItems?.length ?? 0);
    handleStatus(listItems?.length ?? 0);
    input?.addEventListener('input', (e) => {
        handleInputChange(e);
    });
    form?.addEventListener('submit', (e) => {
        e.preventDefault();
    });
}
listFilter();
//# sourceMappingURL=list-filter.js.map